import { createReducer, PayloadAction } from "@reduxjs/toolkit";

import { ActionTypes, IConfigPapelPadrao } from "./types";

export const reducers = createReducer({} as IConfigPapelPadrao, {
  [ActionTypes.SET]: (state, action: PayloadAction<IConfigPapelPadrao>) =>
    action.payload,
});
